<audio #audio [src]="url" preload="metadata"
       (loadedmetadata)="alCargar()"
       (durationchange)="alCargar()"
       (timeupdate)="alAvanzar()"
       (play)="reproduciendo = true"
       (pause)="reproduciendo = false"
       (ended)="reproduciendo = false"></audio>

<!--
  Dos filas y no una: en el panel del chat (350 px) los ocho controles en línea
  dejaban la barra de progreso en una astilla de 30 px, imposible de arrastrar.
  Separada arriba, ocupa todo el ancho y se puede buscar de verdad.
-->
<div class="reproductor">
  <input type="range" class="reproductor__barra"
         min="0" [max]="duracion || 0" step="0.1" [value]="actual"
         [style.--avance.%]="avance"
         aria-label="Posición de la grabación"
         (input)="buscar($event)" />

  <div class="reproductor__mandos">
    <button type="button" class="reproductor__salto" (click)="saltar(-10)" title="Retroceder 10 s">
      <lucide-icon name="rotate-ccw" [size]="14"></lucide-icon>
    </button>

    <button type="button" class="reproductor__play" (click)="alternar()"
            [title]="reproduciendo ? 'Pausar' : 'Reproducir'">
      <lucide-icon [name]="reproduciendo ? 'pause' : 'play'" [size]="15"></lucide-icon>
    </button>

    <button type="button" class="reproductor__salto" (click)="saltar(10)" title="Adelantar 10 s">
      <lucide-icon name="rotate-cw" [size]="14"></lucide-icon>
    </button>

    <span class="reproductor__tiempo">
      {{ reloj(actual) }}<span class="reproductor__separador">/</span>{{ reloj(duracion) }}
    </span>

    <!-- La velocidad importa: repasar una llamada de 8 min a 1x es media tarde. -->
    <button type="button" class="reproductor__velocidad" (click)="cambiarVelocidad()"
            title="Velocidad de reproducción">{{ velocidad }}×</button>

    <a [href]="url" download class="reproductor__salto" title="Descargar el audio">
      <lucide-icon name="download" [size]="14"></lucide-icon>
    </a>
  </div>
</div>

<!--
  La nota de canales solo hace falta cuando la transcripción NO distingue quién
  habla; si cada frase ya viene etiquetada, repetirlo es ruido.
-->
<p *ngIf="!hayHablantes" class="reproductor__canales">
  <lucide-icon name="info" [size]="11"></lucide-icon>
  Agente en el canal izquierdo, cliente en el derecho.
</p>

<!-- Transcripción navegable -->
@if (frases.length > 0) {
  <div class="transcripcion">
    <div class="transcripcion__cabecera">
      <span class="transcripcion__titulo">
        <lucide-icon name="file-text" [size]="11"></lucide-icon>
        Transcripción
      </span>
      <button type="button" class="transcripcion__copiar" (click)="copiar()"
              [title]="copiado ? 'Copiada' : 'Copiar la transcripción'">
        <lucide-icon [name]="copiado ? 'check' : 'copy'" [size]="11"></lucide-icon>
        {{ copiado ? 'Copiada' : 'Copiar' }}
      </button>
    </div>

    <div class="transcripcion__frases" #lista>
      @for (f of frases; track $index) {
        <button type="button" class="frase"
                [attr.data-idx]="$index"
                [class.frase--activa]="$index === activa"
                [class.frase--agente]="f.quien === 'Agente'"
                [class.frase--cliente]="f.quien === 'Cliente'"
                [class.frase--sinsalto]="f.segundos < 0"
                (click)="irA(f.segundos)"
                [disabled]="f.segundos < 0">
          @if (f.quien || f.segundos >= 0) {
            <span class="frase__cabecera">
              @if (f.quien) {
                <span class="frase__quien">{{ f.quien }}</span>
              }
              @if (f.segundos >= 0) {
                <span class="frase__tiempo">{{ reloj(f.segundos) }}</span>
              }
            </span>
          }
          <span class="frase__texto">{{ f.texto }}</span>
        </button>
      }
    </div>
  </div>
}
